import type { CompetitionDetailed, UpdateCompetitionRequest } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updateCompetitionDetails(
  competitionId: string,
  formData: UpdateCompetitionRequest
): Promise<CompetitionDetailed> {
  return requestApiJsonOrThrow<CompetitionDetailed>(`admin/competitions/${competitionId}`, {
    method: 'PATCH',
    body: formData,
  })
}
